// FSANZ Nutrition Information Panel (NIP) helpers. Canonical values are
// stored PER 100g/100mL; the per-serving column is derived from
// serving_size_g. Mirror of format_nip_lines() in backend tspl_printer.py.

export const NIP_ROWS = [
  { label: "Energy", key: "energy_kj", unit: "kJ", dec: 0 },
  { label: "Protein", key: "protein_g", unit: "g", dec: 1 },
  { label: "Fat, total", key: "fat_total_g", unit: "g", dec: 1 },
  { label: "\u2013 saturated", key: "fat_sat_g", unit: "g", dec: 1, indent: true },
  { label: "Carbohydrate", key: "carb_g", unit: "g", dec: 1 },
  { label: "\u2013 sugars", key: "sugars_g", unit: "g", dec: 1, indent: true },
  { label: "Sodium", key: "sodium_mg", unit: "mg", dec: 0 },
];

export const EMPTY_NUTRITION = {
  enabled: false,
  servings_per_pack: "",
  serving_size: "",
  serving_size_g: "",
  energy_kj: "", protein_g: "", fat_total_g: "", fat_sat_g: "",
  carb_g: "", sugars_g: "", sodium_mg: "",
};

// Empty ("") numeric fields must become null before hitting the float model.
export function cleanNutrition(n) {
  if (!n) return n;
  const numeric = ["serving_size_g", "energy_kj", "protein_g", "fat_total_g", "fat_sat_g", "carb_g", "sugars_g", "sodium_mg"];
  const out = { ...n };
  numeric.forEach((k) => {
    out[k] = out[k] === "" || out[k] == null ? null : Number(out[k]);
  });
  return out;
}

export function nipNum(v, unit, dec = 1) {
  if (v === null || v === undefined || v === "") return "-";
  const n = Number(v);
  if (Number.isNaN(n)) return "-";
  const r = dec <= 0 ? Math.round(n) : Math.round(n * 10 ** dec) / 10 ** dec;
  return `${r}${unit}`;
}

// Multi-line text version of the NIP for the read-only canvas preview
// (elementValue renders plain strings, not the panel component).
export function formatNipText(n) {
  if (!n || !n.enabled) return "";
  const rows = computeNipRows(n);
  const out = ["NUTRITION INFORMATION"];
  if (n.servings_per_pack) out.push(`Servings per pack: ${n.servings_per_pack}`);
  if (n.serving_size) out.push(`Serving size: ${n.serving_size}`);
  out.push("              Per serve  Per 100g");
  rows.forEach((r) => out.push(`${r.label}  ${r.perServe}  ${r.per100g}`));
  return out.join("\n");
}
export function computeNipRows(nutrition) {
  const g = Number(nutrition?.serving_size_g);
  const hasServe = nutrition?.serving_size_g !== "" && nutrition?.serving_size_g != null && !Number.isNaN(g) && g > 0;
  return NIP_ROWS.map((r) => {
    const raw = nutrition?.[r.key];
    const v100 = raw === "" || raw == null ? null : Number(raw);
    const serve = v100 != null && hasServe ? (v100 * g) / 100 : null;
    return {
      ...r,
      perServe: nipNum(serve, r.unit, r.dec),
      per100g: nipNum(v100, r.unit, r.dec),
    };
  });
}
